import React, { FC, useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Navbar as GlobalNavbar, NavbarItem } from "../../../../Components/Layout/Navbar";
import Header from "../../../../Components/Layout/Header";

const Navbar: FC = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState<NavbarItem[]>([]);

    useEffect(() => {
        setItems([
            {
                i18nLabel: 'Usage',
                path: ''
            },
            {
                i18nLabel: 'Configuration',
                path: 'configuration'
            },
            {
                i18nLabel: 'Audit Logs',
                path: 'audit-logs'
            }
        ]);
    }, []);

    return (
        <>
            <Header
                title="AI Autotagging"
                prev={() => {
                    navigate('/admin/edition');
                }}
            />
            <GlobalNavbar locationBase="/admin/edition/ai" items={items} />
            <Outlet />
        </>
    );
};

export default Navbar;
